import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractLandingPageContentComponent } from '../landing-page.component';
import { UserStorage } from '@scisys-uim/uim-common';

@Component({
  selector: 'app-landing-page-firearms',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class FirearmsLandingPageComponent extends AbstractLandingPageContentComponent implements OnInit {

  queryParams: any = {};

  constructor(protected userStorage: UserStorage, private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }


  showPendingAssignments(): boolean {
    return this.userStorage.currentUserHasAnyAuthority('READ_FIREARM_ASSIGNMENT');
  }
}